import { render, staticRenderFns } from "./languageJm.vue?vue&type=template&id=c914ccd0&scoped=true"
import script from "./languageJm.vue?vue&type=script&lang=js"
export * from "./languageJm.vue?vue&type=script&lang=js"
import style0 from "./languageJm.vue?vue&type=style&index=0&id=c914ccd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c914ccd0",
  null
  
)

export default component.exports